import { ethers, BigNumberish, BigNumber } from 'ethers'
import { useWeb3React } from '@web3-react/core'
import useSWR from 'swr'
import { CacheKey } from 'web/lib/cache-keys'
import { Blood } from 'web/types/ethers-contracts'
import { GawdsContractFactory } from 'web/lib/contract'

// as you spend tokens, your allowance will no longer be maxUint256
// so just naively check that you have allowed a very high amount of blood and call that 'unlimited'
export const isUnlimitedAllowance = (amount: BigNumberish) => {
  if (!amount) return false
  const reallyHigh = ethers.utils.parseEther('1000000')
  return reallyHigh.lt(amount)
}

export default function useBloodAllowance(contractAddress: string) {
  const { active, account } = useWeb3React()
  const energyContract: Blood = GawdsContractFactory.get("Blood") as Blood

  const { data, mutate } = useSWR(CacheKey.bloodAllowance(account, contractAddress), async () => {
    if (!active || !contractAddress) return null
    return await energyContract.allowance(account, contractAddress)
  }, {
    refreshInterval: 1000 * 60 * 30, // 30 minutes
  })

  return {
    allowance: data || BigNumber.from(0),
    isUnlimitedAllowance,
    mutate
  }
}